import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";

const MultiSelectAdd = ({ options, onChange,setSelectedOptions,selectedOptions }) => {
  // Transform options to required format
  const formattedOptions = options?.map(opt => ({
    value: opt.adFormID,
    label: opt.adFormName,
    ...opt
  }));

  // Handle selection change
  const handleSelectionChange = (selected) => {
    const selectedIds = selected?.map(option => option.value) || [];
    const selectedNames = selected?.map(option => option.label) || [];

    setSelectedOptions(selected || []);
    onChange({ selectedIds, selectedNames });
  };

  // Custom rendering for options with checkboxes
  const customOption = ({ data, innerRef, innerProps }) => (
    <div ref={innerRef} {...innerProps} style={{ display: "flex", alignItems: "center", padding: "5px 10px", cursor: "pointer" }}>
      <input
        type="checkbox"
        checked={selectedOptions.some((option) => option.value === data.value)}
        readOnly
        style={{ marginRight: "10px" }}
      />
      {data.label}
    </div>
  );

  // Custom dropdown indicator
  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <span className="pointer-events-none">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995" 
            stroke="#245CEA" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round">
          </path>
        </svg>
      </span>
    </components.DropdownIndicator>
  );

  // Define styles
  const customStyles = {
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "16px",
      padding: "0px",
    }),
  };

  // Custom components
  const customComponents = {
    Option: customOption,
    DropdownIndicator,
    IndicatorSeparator: () => null,
  };

  
  return (
    <div className="  border_color border text-base rounded-lg block p-1 appearance-none w-[730px]" style={{ minHeight: '3rem' }}>
    <Select
      options={formattedOptions}
      components={customComponents}
      isMulti
      value={selectedOptions}
      onChange={handleSelectionChange}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      placeholder="Search Ads"
      className="appearance-none text-base"
      styles={customStyles}
    />
    </div>
  );
};

export default MultiSelectAdd;
